import getMuiTheme from 'material-ui/styles/getMuiTheme';
import muiColors from './muiColors';
import p from './paletteHex';

const muiTheme = getMuiTheme({
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  borderRadius: 8,
  palette: muiColors,
  button: {
    height: 40,
  },
  raisedButton: {
    color: p.white,
    textColor: p.defaultText,
    secondaryTextColor: p.defaultText,
    disabledColor: 'transparent',
    fontWeight: 500,
    borderRadius: 8,
  },
  flatButton: {
    fontWeight: 500,
  },
  textField: {
    borderColor: p.border,
    focusColor: p.primary,
    errorColor: p.error,
  },
  h2: {
    fontWeight: 500,
  }
});

export default muiTheme;
